module.exports = __webpack_public_path__ + "img/img4.71aa4f01.jpg";